<template>
  <div id="single-dropdown">
    <div id="label" v-if="label !== ''">
      <label class="title">{{label}}</label>
    </div>
    <div class="my-1">
      <b-dropdown class="custom_dropdown"
                  id="btn"
                  toggle-class="cutom_dropdown_btn"
                  :menu-class="{cutom_dropdown_menu: true, none: options.length === 0}"
                  size="sm"
                  :text="selectedText">
        <b-dropdown-item id="dropdown-menu" v-for="(option,index) in options"
                         :key="index"
                         :value="option.value"
                         @click="selectChange(index)">
          {{option.text}}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
/*
  ※주의 : 데이터 추가할때 주석부분에도 추가해주세요.※
  =================================================
  ※ prop data ※
  [label : String]
  [currentValue: Number,String,Boolean,Object]
  [placeHolder: String]
  [options : Array] => options key 값에 무조건 text(화면에 보여지는 값)이 있어야함.
  =================================================
  ※ Event ※
  change => 값 변경시 event 발생
  =================================================
*/
export default {
  props: {
    label: {
      type: String,
      default: '선택'
    },
    currentValue: {
      type: [Number, String, Boolean, Object],
      default: null
    },
    placeHolder: {
      type: String,
      default: '선택'
    },
    options: {
      type: [Array, Object],
      default: function () {
        return [{ text: '선택', value: null }]
      }
    }
  },
  data () {
    return {
      selectedValue: this.currentValue,
      selectedText: this.placeHolder,
      items: []
    }
  },
  methods: {
    selectChange: function (idx) {
      this.selectedText = this.options[idx].text
      this.selectedValue = this.options[idx].value
      this.$emit('selectChange', this.options[idx])
    }
  },
  watch: {
    options: {
      deep: true,
      handler () {
        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].value === this.selectedValue) {
            this.selectedText = this.options[i].text
            break
          }
        }
      }
    }
  }
}
</script>
<style scoped>
/deep/ .custom_dropdown {
  font-style: normal;
  font-weight: normal;
  min-width: 100%;
}

/deep/ .cutom_dropdown_btn {
  background: #FFFFFF !important;
  border: 1px solid #E5E5E5 !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
  color: #222222 !important;
  font-size: 12px;

  padding: 5px !important;
}

/deep/ .cutom_dropdown_btn:focus {
  box-shadow: none;
}

/deep/ .show .cutom_dropdown_btn {
  color: #18A0FB !important;
  border: 1px solid #18A0FB !important;
}

/deep/ .cutom_dropdown_menu {
  background: #FFFFFF !important;
  border: 1px solid #18A0FB !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: #222222;
  min-width: 0;
  max-height: 200px;
  overflow-y: auto;
}

/deep/ .cutom_dropdown_menu.none {
  display: none;
}

/deep/ .cutom_dropdown_menu .active {
  background: #F5F6FA;
  color: #222222 !important;
}

.title {
  font-family: Roboto;
  color: #000000;
}

/deep/ .btn-secondary:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;

}

/deep/ .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none;
}

/deep/ .dropdown-toggle::after {
  position: absolute;
  right: 7px;
  top: 50%;
  margin-top: -2px;
}
</style>
